/* @flow */

import $ from 'jquery';
import moment from 'moment';
import formSerialize from 'form-serialize';
import Grid from '../grid';
import imagemUploadTabela from '../view/imagem-tabela';
import getElementoPorId from '../utils/get-elemento-por-id';
import xhr from '../utils/xhr';
import popoverAtivacao from './popover-ativacao';
import {
    preencherFormularioUrlsLojas,
} from './eventos-formularios/urls-lojas';
import cadastroUrlsLojas from './nova-empresa-por-etapa/urls-lojas';
import {
    buscarPackages,
    preencherFormularioPackages,
} from './eventos-formularios/packages';
import {
    preencherFormularioRecursos, setOnSubmitRecursos,
} from './eventos-formularios/recursos';
import cadastroAplicativo from './nova-empresa-por-etapa/aplicativo-estabelecimento';
import CadastroEmpresaPorEtapa from './nova-empresa-por-etapa/CadastroEmpresaPorEtapa';
import cadastroContatos from './nova-empresa-por-etapa/contatos-estabelecimento';
import getDadosFormulario from './nova-empresa-por-etapa/get-formulario';
import mensagemSucesso, { mensagemErro } from './nova-empresa-por-etapa/mensagem-sucesso';
import cadastroPackages from './nova-empresa-por-etapa/packages';
import proximaEtapa from './nova-empresa-por-etapa/proximaEtapa';
import preencherFormEstabelecimento,
{ editarEstabelecimento } from './eventos-formularios/estabelecimento';
import preencherFormContatos from './eventos-formularios/contato';
import preencherFormEndereco from './eventos-formularios/endereco';
import preencherFormularioCobranca from './eventos-formularios/formulario-cobranca';
import ativacaoItensMenu from './eventos-formularios/ativacao-itens-menu';
import editarEndereco from '../enderecos/editar';
import detalhes from './view/detalhes';
import applyLoading from '../utils/apply-loading';
import getEnderecoPorEmpresasId from './get-endereco-por-empresas-id';
import getContatosPorEmpresasId from './get-contatos-por-empresas-id';
import getLogsAtivacaoPorEmpresasId from './get-logs-ativacao-por-empresas-id';
import getCoresPorEmpresasId from './get-cores-por-empresas-id';
import previewImagem from '../utils/preview-imagem';
import {
    type Empresa,
    type LogAtivacao,
    type UrlLojas,
    type Packages,
    type Recurso,
} from '../empresa/types';
import { type Contato } from '../usuario/types';
import { type Endereco } from '../enderecos/types';
import exibirErro from '../utils/exibir-erro';
import cadastroEndereco from './nova-empresa-por-etapa/endereco-estabelecimento';
import resetFormulario from './reset-formulario';
import viewEmpresa from './view/empresa';
import api from '../utils/api';
import criarDiretorioImagensUpload from '../utils/criar-diretorio-imagens-upload';
import inputFileComPreview from '../utils/input-file-com-preview';
import extratosPorEmpresa from './extratos-por-empresa';
import gridMensalidades from './grid-mensalidades';
import funcionariosPorEmpresa from './funcionarios-por-empresa';
import adicionarFuncionario from './adicionar-funcionario';
import getInputPorId from '../utils/get-input-por-id';
import { type Cobranca } from '../cobranca/types';
import removerFormatacaoDinheiro from '../utils/remover-formatacao-dinheiro';
import { editarDadosWebLoja, getDadosFormularioWebLoja, preencherFormularioWebLoja } from './eventos-formularios/web-loja';

export const buttonAtivo = (ativo: 0 | 1) => `
<button
    class="btn btn-${ativo ? 'success' : 'danger'} m-btn--pill btn-sm button-ativo"
    type="button">
    ${ativo ? 'Sim' : 'Não'}
</button>`;


type ViewEmpresa = {
    id: number,
    representante: string,
    fantasia: string,
    empresasTiposId: number,
    ativo: string,
    logo: string,
    dataCadastro: string,
};

export default class GridEmpresas extends Grid {
    novaEmpresa() {
        const btnNovaEmpresa = getElementoPorId('nova-empresa');
        if (!btnNovaEmpresa) {
            return;
        }

        btnNovaEmpresa.onclick = () => {
            resetFormulario();
            this.mostarProfileCadastro();
            this.esconderGrid();
            this.mostrarFormularioEstabelecimento();
            (new CadastroEmpresaPorEtapa()).cadastrarEmpresa();
        };
    }

    processar(empresas: Empresa[]): ViewEmpresa[] {
        return empresas.map(empresa => ({
            id: empresa.id,
            fantasia: empresa.fantasia,
            empresasTiposId: empresa.empresasTiposId,
            ativo: buttonAtivo(empresa.ativo),
            logo: empresa.logo ? imagemUploadTabela(empresa.logo) : '',
            dataCadastro: empresa.dataCadastro ? moment(empresa.dataCadastro).format('L') : '',
            representante: empresa.representante,
            dataRecebimento: empresa.dataCadastro ? moment(empresa.dataCadastro).add(30, 'days').format('L') : '',
        }));
    }

    executarPorLinha(row: HTMLTableRowElement, empresa: Empresa) {
        const ativo = row.querySelector('.button-ativo');
        const extratos = row.querySelector('.extratos');
        const funcionarios = row.querySelector('.funcionarios');
        const addFuncionarios = row.querySelector('.novo-funcionario');
        const btnMensalidades = row.querySelector('.btn-mensalidades');
        const editar = row.querySelector('.editar');

        if (ativo) {
            ativo.onclick = () => popoverAtivacao(empresa, ativo)
                .then(applyLoading(motivo => this.ativacao(empresa, motivo)));
        }

        if (!extratos || !funcionarios || !addFuncionarios || !btnMensalidades) {
            return;
        }

        this.exibirMensalidade(btnMensalidades, empresa);
        this.exibirExtratos(extratos, empresa);
        this.exibirFuncionarios(funcionarios, empresa);
        this.adicionarFuncionario(addFuncionarios, empresa);

        if (editar) {
            editar.onclick = applyLoading(async () => {
                const [
                    { data: contatos },
                    { data: endereco },
                    { data: logsAtivacao },
                    { data: urlLojas },
                    { data: packages },
                    { data: recursos },
                    { data: cobranca },
                ] = await Promise.all([
                    getContatosPorEmpresasId(empresa.id),
                    getEnderecoPorEmpresasId(empresa.id).catch(() => ({ data: null })),
                    getLogsAtivacaoPorEmpresasId(empresa.id),
                    api.getUrlsLojas(empresa.id).catch(() => ({ data: null })),
                    buscarPackages(empresa.id).catch(() => ({ data: null })),
                    api.getRecursosPorEmpresasId(empresa.id),
                    api.getDadosCobranca(empresa.id),
                ]);

                this.mostarProfileEditar(empresa);

                this.carregarDetalhes({ logsAtivacao });

                this.eventosEstabelecimento(empresa);
                this.eventosContatos(empresa, contatos);
                this.eventosEndereco(empresa, endereco);
                this.eventosFormularioCores(empresa);
                this.eventosFormularioWebLoja(empresa);
                this.eventosFormularioUrlsLoja(empresa, urlLojas);
                this.eventosFormularioPackages(empresa, packages);
                this.eventosFormularioRecursos(empresa, recursos);
                this.eventosFormularioCobranca(empresa, cobranca);

                this.btnVoltar();
                this.mostrarEditar();
            });
        }
    }

    exibirMensalidade(btnMensalidades: HTMLElement, empresa: Empresa) {
        btnMensalidades.onclick = () => gridMensalidades(empresa);
    }

    exibirExtratos(extratos: HTMLElement, empresa: Empresa) {
        extratos.onclick = () => extratosPorEmpresa(empresa.id);
    }

    exibirFuncionarios(funcionarios: HTMLElement, empresa: Empresa) {
        funcionarios.onclick = () => funcionariosPorEmpresa(empresa.id, empresa.fantasia);
    }

    adicionarFuncionario(btnAdicionar: HTMLElement, empresa: Empresa) {
        btnAdicionar.onclick = () => adicionarFuncionario(empresa);
    }

    mostarProfileEditar(empresa: Empresa) {
        const profileEditar = getElementoPorId('card-profile-editar');
        const profileCadastro = getElementoPorId('card-profile-cadastro');
        profileEditar.style.display = '';
        profileCadastro.style.display = 'none';
        profileEditar.innerHTML = viewEmpresa(empresa);
    }

    mostarProfileCadastro() {
        const profileEditar = getElementoPorId('card-profile-editar');
        const profileCadastro = getElementoPorId('card-profile-cadastro');
        const classVendasSemPolling = document.querySelector('.vendas-sem-polling');
        const classUsaEstoque = document.querySelector('.usa-estoque');

        profileEditar.style.display = 'none';
        profileCadastro.style.display = '';

        if (classVendasSemPolling) {
            classVendasSemPolling.hidden = false;
        }
        if (classUsaEstoque) {
            classUsaEstoque.hidden = false;
        }
    }

    carregarDetalhes({
        logsAtivacao,
    }: {
        logsAtivacao: LogAtivacao[],
    }) {
        getElementoPorId('log').style.display = '';

        getElementoPorId('logs-empresa').innerHTML = detalhes({
            logsAtivacao,
        });
    }

    btnVoltar() {
        const voltar = document.querySelector('#btn-voltar .voltar');
        if (!voltar) {
            return;
        }
        voltar.onclick = () => {
            this.esconderEditar();
            ativacaoItensMenu('');
            this.pesquisar();
        };
    }

    mostrarFormularioEstabelecimento() {
        getElementoPorId('log').style.display = 'none';
        $('#empresa a').click();
        const gridEstabelecimento = getElementoPorId('grid-estabelecimento');
        gridEstabelecimento.style.display = '';
        this.btnVoltar();
    }

    esconderEditar() {
        const portlet = getElementoPorId('grid-estabelecimento');
        this.mostrarGrid();
        portlet.style.display = 'none';
        this.pesquisar();
    }

    mostrarEditar() {
        const portlet = getElementoPorId('grid-estabelecimento');
        this.esconderGrid();
        portlet.style.display = '';
    }

    esconderGrid() {
        this.container.style.display = 'none';
    }

    mostrarGrid() {
        this.container.style.display = '';
    }

    eventosEstabelecimento(empresa: Empresa) {
        preencherFormEstabelecimento(empresa);
        const form = getElementoPorId('formulario-empresa');
        const inputVendasSemPolling = getInputPorId('vendas-sem-polling');
        const inputUsaEstoque = getInputPorId('usa-estoque');

        form.onsubmit = async (e: Event) => {
            const getEmpresaFormulario = (): Empresa => formSerialize(document.forms.namedItem('formulario-empresa'), { hash: true });
            const dados = getEmpresaFormulario();
            dados.vendasSemPolling = inputVendasSemPolling.checked === true ? '1' : '0';
            dados.usaEstoque = inputUsaEstoque.checked === true ? '1' : '0';
            dados.valorMinimoPedido = removerFormatacaoDinheiro(getInputPorId('valor-minimo-pedido-empresa').value);
            e.preventDefault();
            try {
                await editarEstabelecimento(empresa.id, dados);
                mensagemSucesso('Estabelecimento editado.');
                proximaEtapa('contatos');
            } catch (err) {
                exibirErro(err);
            }
        };
    }

    eventosContatos(empresa: Empresa, contatos: Contato[]) {
        preencherFormContatos(contatos);
        cadastroContatos(empresa.id);
    }

    eventosFormularioCobranca(empresa: Empresa, cobranca: ?Cobranca) {
        const form = getElementoPorId('formulario-cobranca');

        if (cobranca) {
            preencherFormularioCobranca(cobranca);
            form.onsubmit = (e) => {
                if (!cobranca.cobrancaId) {
                    const dados = getDadosFormulario(form);
                    dados.empresasId = empresa.id;
                    dados.fantasia = empresa.fantasia;
                    e.preventDefault();
                    try {
                        xhr.post('/empresas/cobranca', dados);
                        mensagemSucesso('Dados da cobrança gravados.');
                        proximaEtapa('aplicativo');
                    } catch (err) {
                        exibirErro(err);
                    }
                } else {
                    const dados = getDadosFormulario(form);
                    dados.empresasId = empresa.id;
                    dados.fantasia = empresa.fantasia;
                    e.preventDefault();
                    try {
                        xhr.put(`/empresas/cobranca/${empresa.id}`, dados);
                        mensagemSucesso('Dados da cobrança editados.');
                        proximaEtapa('aplicativo');
                    } catch (err) {
                        exibirErro(err);
                    }
                }
            };
        }
    }

    eventosEndereco(empresa: Empresa, endereco: ?Endereco) {
        const form = getElementoPorId('formulario-endereco');
        if (endereco) {
            preencherFormEndereco(endereco);
            form.onsubmit = async (e) => {
                e.preventDefault();
                const dados = getDadosFormulario(form);
                try {
                    await editarEndereco(dados);
                    await editarEstabelecimento(empresa.id, { retiradaLocal: dados.retiradaLocal });
                    mensagemSucesso('Endereço editado.');
                    proximaEtapa('aplicativo');
                } catch (err) {
                    exibirErro(err);
                }
            };
        } else {
            cadastroEndereco(empresa.id);
        }
    }

    async publicacaoApp(empresa: Empresa) {
        const botao = getElementoPorId('publicacao-app');
        try {
            botao.onclick = () => {
                xhr.post(`/empresas/${empresa.id}/publicacao-app`);
                mensagemSucesso('Email enviado.');
            };
        } catch (err) {
            exibirErro(err);
        }
    }

    async eventosFormularioUrlsLoja(empresa: Empresa, urlLojas: ?UrlLojas) {
        if (urlLojas) {
            preencherFormularioUrlsLojas(urlLojas);
            this.publicacaoApp(empresa);
        }

        if (!urlLojas) {
            cadastroUrlsLojas(empresa.id);
        }
    }

    async eventosFormularioPackages(empresa: Empresa, packages: ?Packages) {
        if (packages) {
            preencherFormularioPackages(packages);
        }

        cadastroPackages(empresa.id, () => {
            mensagemSucesso('Packages editadas');
            this.esconderEditar();
        });
    }

    async eventosFormularioRecursos(empresa: Empresa, recursos: Recurso[]) {
        preencherFormularioRecursos(recursos);

        setOnSubmitRecursos(empresa.id, () => {
            mensagemSucesso('Recursos editados');
            this.esconderEditar();
        });
    }

    async eventosFormularioWebLoja(empresa: Empresa) {
        preencherFormularioWebLoja(empresa);

        getElementoPorId('formulario-web-loja').onsubmit = (e: Event) => {
            e.preventDefault();
            try {
                editarDadosWebLoja(empresa.id, getDadosFormularioWebLoja());
                mensagemSucesso('Configurações web editadas com sucesso');
                this.pesquisar();
            } catch (error) {
                console.error('Erro:', error);
                mensagemErro('Houve erro ao editar. Tente novamente.');
            }
        };
    }

    async carregarAplicativo(empresa: Empresa) {
        const { data: cores } = await getCoresPorEmpresasId(empresa.id)
            .catch(() => ({ data: null }));

        if (cores) {
            $('[name=primaria]').attr('value', cores.primaria).html(cores.primaria).css('color', cores.primaria);
            $('[name=secundaria]').attr('value', cores.secundaria).html(cores.secundaria).css('color', cores.secundaria);
        }

        if (empresa.logo) {
            previewImagem.set('.logo-empresa', criarDiretorioImagensUpload(empresa.logo));
        }

        if (empresa.imagemFundo) {
            previewImagem.set('.imagem-fundo-empresa', criarDiretorioImagensUpload(empresa.imagemFundo));
        }

        inputFileComPreview('logo-empresa');
        inputFileComPreview('imagem-fundo-empresa');

        // $('#cor-primaria-empresa').on('change', (element) => {
        //     // $('[name=primaria]')
        // .attr('value', cores.primaria).html(cores.primaria).css('color', cores.primaria);
        //     console.log(element);
        // });

        // // $('#cor-secundaria-empresa').on('input', () => {
        // //     $('[name=secundaria]')
        // .attr('value', cores.secundaria).html(cores.secundaria).css('color', cores.secundaria);
        // //     console.log('iouerioureoiwure');
        // // });
    }

    eventosFormularioCores(empresa: Empresa) {
        this.carregarAplicativo(empresa);
        cadastroAplicativo(empresa.id);
    }

    async ativacao(empresa: Empresa, motivo: string) {
        await xhr.put(`/empresas/${empresa.id}`, {
            ativo: Number(!empresa.ativo),
            motivo,
        });
        this.pesquisar();
    }
}
